export const SET_USER_SPORTNECTIONS = 'SET_USER_SPORTNECTIONS'
export const SET_USER_PHOTOS = 'SET_USER_PHOTOS'
export const CLEAR_USER_PHOTOS = 'CLEAR_USER_PHOTOS'
export const SET_BUSY_PHOTOS = 'SET_BUSY_PHOTOS'
export const SET_PHOTOS_LAST_EVALUATED_KEY = 'SET_PHOTOS_LAST_EVALUATED_KEY'

/**
 * Set user sportnections to store
 *
 * @param {Object} state
 * @param {Object} data
 * @returns {{sportnections: *}}
 */
function setSportnections(state, data) {
    return {
        ...state,
        sportnections: data,
    }
}

/**
 * Set photos array into existing photos
 *
 * @param {Object} state
 * @param {array} photos
 * @param {boolean} append
 * @return {{photos: *[]}}
 */
function setPhotos(state, photos, append = false) {
    return {
        ...state,
        photos: append ? [
            ...state.photos,
            ...photos,
        ] : photos,
    }
}

/**
 * Clear setted photos
 *
 * @param {Object} state
 * @return {{photos: []}}
 */
function clearPhotos(state) {
    return {
        ...state,
        photos: [],
    }
}

/**
 * Set photos loading busy / unbusy
 *
 * @param {Object} state
 * @param {boolean} busy
 * @return {{busyPhotos: *}}
 */
function setBusyPhotos(state, busy) {
    return {
        ...state,
        busyPhotos: busy,
    }
}

/**
 * Set photos next token
 *
 * @param {Object} state
 * @param {string} lastEvaluatedKey
 * @return {{busyPhotos: *}}
 */
function setPhotosLastEvaluatedKey(state, lastEvaluatedKey) {
    return {
        ...state,
        photosLastEvaluatedKey: lastEvaluatedKey,
    }
}

/**
 * Reducer for profile
 * @param {Object} state
 * @param {Object} action
 * @returns {*}
 */
export default function reducer(state = [], action) {
    switch(action.type) {
        case SET_USER_SPORTNECTIONS: return setSportnections(state, action.sportnections)
        case SET_USER_PHOTOS: return setPhotos(state, action.photos, action.append || false)
        case CLEAR_USER_PHOTOS: return clearPhotos(state)
        case SET_BUSY_PHOTOS: return setBusyPhotos(state, action.busy)
        case SET_PHOTOS_LAST_EVALUATED_KEY: return setPhotosLastEvaluatedKey(state, action.lastEvaluatedKey)
        default: return state
    }
}
